import { defineMessages } from 'react-intl';

export default defineMessages({
	continueWithAtlassianAccountButton: {
		defaultMessage: 'Continue with Atlassian account',
		description: 'The redirect button text for login with single sign-on',
		id: 'cv.login.sso.button.text',
	},
	emailLabel: {
		defaultMessage: 'Email address',
		description: 'Label for the email address input field on the SSO login form',
		id: 'cv.login.sso.email.label',
	},
	atlassianAccountInfoTitle: {
		defaultMessage: 'Your Atlassian account',
		description: 'Title of atlassian account info section',
		id: 'cv.login.sso.atlassian.account.info.title',
	},
	atlassianAccountInfoContent: {
		defaultMessage:
			'Make things easier by using one account across all of your Atlassian products. {supportLink}',
		description: 'Content of atlassian account info section',
		id: 'cv.login.sso.atlassian.account.info.content',
	},
	atlassianAccountInfoContentAppify: {
		defaultMessage:
			'Make things easier by using one account across all of your Atlassian apps. {supportLink}',
		description: 'Content of atlassian account info section',
		id: 'cv.login.sso.atlassian.account.info.content-appify',
	},
	atlassianAccountInfoLink: {
		defaultMessage: 'Learn more',
		description: 'Learn more link of atlassian account info section',
		id: 'cv.login.sso.atlassian.account.info.link',
	},
});
